import React from 'react'

export default function HeaderMoves() {
  return (
      <div className="header__info title longer">
          <span>KNOWN MOVES</span>
      </div>
  )
}
